module.exports = __webpack_public_path__ + "static/media/Twitter.714da466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Twitter.svg
// module id = 147
// module chunks = 0